import { get, post, put, remove } from "./apiClient";

export default {
  async convertAndEditDevicePlaceholder(
    facilityId,
    placeHolderId,
    serialNumber,
    deviceUpdates
  ) {
    return await put(
      `facility/${encodeURIComponent(
        facilityId
      )}/devicePlaceholders/${encodeURIComponent(
        placeHolderId
      )}/convertandedit`,
      { serialNumber, deviceUpdates }
    );
  },

  async convertDevicePlaceholder(
    facilityId,
    devicePlaceholderId,
    serialNumber
  ) {
    return await put(
      `facility/${encodeURIComponent(
        facilityId
      )}/devicePlaceholders/${encodeURIComponent(devicePlaceholderId)}/convert`,
      { serialNumber }
    );
  },

  async createRoomTemplatePlaceholders(facilityId, locationIds) {
    // facilityId is in the body (not a path segment), so no encoding needed here
    return await post(`roomTemplateDevicePlaceholders`, {
      facilityId,
      locationIds
    });
  },

  async createDevicePlaceholder(locationIds, devicePlaceholder) {
    return await post(`devicePlaceholders`, { locationIds, devicePlaceholder });
  },

  async deletePlaceholder(facilityId, deviceId) {
    await remove(
      `facility/${encodeURIComponent(
        facilityId
      )}/devicePlaceholders/${encodeURIComponent(deviceId)}`
    );
  },

  async editDevicePlaceholder(devicePlaceholderId, devicePlaceholder) {
    return await put(
      `devicePlaceholders/${encodeURIComponent(devicePlaceholderId)}`,
      devicePlaceholder
    );
  },

  async getById(devicePlaceholderId) {
    return await get(
      `devicePlaceholders/${encodeURIComponent(devicePlaceholderId)}`
    );
  }
};
